import React, { ReactElement } from 'react';
import { ListRenderer } from '@feast-it/ui/light';
import { Supplier } from '../../../../types';
import { SupplierV2 } from '../Supplier';
import { Container } from './SuppliersGrid.styled';

interface SuppliersGridProps {
  results: Supplier[];
  showLocation: boolean;
  locationName: string;
}

export function SuppliersGrid({
  results,
  showLocation,
  locationName,
}: SuppliersGridProps): ReactElement {
  return (
    <Container>
      <ListRenderer
        items={results}
        render={({ item: supplier }) => (
          <SupplierV2
            supplierData={supplier}
            location={showLocation ? locationName : null}
          />
        )}
      />
    </Container>
  );
}
